import { useEffect, useRef, useState } from "react";
import { TagPage, pagesWithIndex } from "@/components/tags/TagPages";
import { MM } from "@/lib/tagLayouts";

function useWidth(ref) {
  const [w, setW] = useState(600);
  useEffect(() => {
    const ro = new ResizeObserver(([e]) => setW(e.contentRect.width));
    if (ref.current) ro.observe(ref.current);
    return () => ro.disconnect();
  }, [ref]);
  return w;
}

export function TagPreview({ L, tags, fields, bizName, start }) {
  const ref = useRef(null);
  const width = useWidth(ref);
  const a4 = L.kind === "a4";
  const pw = (a4 ? 210 : L.w) * MM, ph = (a4 ? 297 : L.h) * MM;
  const scale = Math.min(a4 ? 1 : 2.4, (width - 8) / pw);
  const pages = pagesWithIndex(L, tags, start);
  const max = a4 ? 2 : 12;
  return (
    <div ref={ref} data-testid="tag-preview" data-layout={L.kind} data-tag-count={tags.length}>
      {tags.length === 0 ? (
        <div className="grid h-48 place-items-center rounded-2xl border-2 border-dashed border-slate-200 text-sm text-slate-400" data-testid="tag-preview-empty">
          Select products to see the preview
        </div>
      ) : (
        <div className={a4 ? "space-y-4" : "flex flex-wrap gap-3"}>
          {pages.slice(0, max).map((p) => (
            <div key={p.pi} style={{ width: pw * scale, height: ph * scale }} className="overflow-hidden rounded-[3px] bg-white shadow-[0_10px_30px_-14px_rgba(15,23,42,.45)] ring-1 ring-slate-200">
              <div style={{ transform: `scale(${scale})`, transformOrigin: "top left", width: pw, height: ph }}>
                <TagPage L={L} {...p} fields={fields} bizName={bizName} outline />
              </div>
            </div>
          ))}
        </div>
      )}
      {pages.length > max && <div className="mt-3 font-mono text-xs text-slate-500" data-testid="tag-preview-more">+ {pages.length - max} more {a4 ? "sheets" : "labels"} will print</div>}
    </div>
  );
}
